import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/**
 * ToastProvider configures and renders a shared react-toastify container for this app
 * @returns {JSX.Element}
 */
const ToastProvider = () => {
    return (
        <ToastContainer 
            position="top-right"
            autoClose={3000} 
            hideProgressBar={false}
            closeOnClick
            pauseOnHover 
            theme="light" 
        />
    );
};

export default ToastProvider;
